import React, { ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Paper, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import TimesheetIcon from '../icons/TimesheetIcon.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(0, 2, 0, 0),
    minHeight: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    textAlign: 'center'
  },
  icon: {
    marginTop: theme.spacing(-5),
    marginBottom: theme.spacing(2),
    fontSize: theme.spacing(20),
    opacity: '56%',
    [theme.breakpoints.down('xl')]: {
      height: '25vh'
    }
  },
  rebrandingIcon: {
    color: theme.palette.timesheetLabel.customLabelChipColor,
    fontSize: theme.spacing(22),
    opacity: '50%',
    height: theme.spacing(18.5),
    width: theme.spacing(18.5),
    maxWidth: '350px'
  },
  title: {
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
      fontSize: '6vh'
    }
  },
  subtitle: {
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('lg')]: {
      fontSize: '3vh'
    }
  }
}));

const TimesheetNotFound = (): ReactElement => {
  const classes = useStyles();

  return (
    <Paper
      data-testid="ts-error-page-not-found"
      className={classes.root}
      square
      elevation={0}
    >
      <img
        src={TimesheetIcon}
        alt="No Timesheet found"
        className={classes.rebrandingIcon}
      />

      <Typography variant="h3" className={classes.title}>
        <FormattedMessage id="tsErrorPage.rebrandingTitle" />
      </Typography>

      <Typography variant="h6" className={classes.subtitle}>
        <FormattedMessage id="tsErrorPage.rebrandingSubtext" />
      </Typography>
    </Paper>
  );
};

export default TimesheetNotFound;
